export default function ({customStyle, children}) {return(
	<div className={customStyle && customStyle.background ? 'contentBlockWrapper' : ''}
		 style={customStyle ? {position: 'relative', ...customStyle} : {position: 'relative'}}>
		{children}
	</div>
)}